import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  TextField,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { useAuth } from "../AuthContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's CSS

// Import Quill's core and additional modules
import Quill from "quill";
import "quill/dist/quill.snow.css"; // Import the theme CSS

// Define custom toolbar options
const toolbarOptions = [
  [{ font: [] }],
  [{ size: [] }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["image"],
  // ["blockquote", "code-block"],
];

// Register custom formats
const Size = Quill.import("attributors/style/size");
Quill.register(Size, true);

const Font = Quill.import("formats/font");
Font.whitelist = [
  "arial",
  "comic-sans",
  "courier",
  "georgia",
  "helvetica",
  "impact",
  "times-new-roman",
  "trebuchet-ms",
  "verdana",
];
Quill.register(Font, true);

const NewPost = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const { token, uid } = useAuth();

  const getUserNameFromToken = () => {
    try {
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      return decodedToken.userName;
    } catch (error) {
      console.error("Failed to decode token", error);
      return "";
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("content", content); // Rich-text content
      formData.append("userId", uid);
      formData.append("userName", getUserNameFromToken());
      if (selectedFile) {
        formData.append("photos", selectedFile);
      }

      await axios.post("https://sirius.runasp.net/api/Post", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setTitle("");
      setContent("");
      setSelectedFile(null);
      setSuccessMessage("Post created successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error(
        "There was an error creating the post!",
        error.response?.data || error.message
      );
      setError(
        `Failed to create the post. Error: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <Card
      style={{
        width: "700px",
        overflow: "scroll",
        overflowX: "hidden",
        margin: "1rem auto",
        padding: "1rem",
      }}
    >
      <CardContent>
        <Typography variant="h5">Create New Post</Typography>
        <TextField
          fullWidth
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          margin="normal"
        />
        <ReactQuill
          value={content}
          onChange={(value) => setContent(value)}
          theme="snow"
          modules={{ toolbar: toolbarOptions }}
          placeholder="Write your content here..."
          style={{
            marginBottom: "1rem",
          }}
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ margin: "1rem 0" }}
        />
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        {successMessage && (
          <Typography
            variant="body2"
            style={{ color: "green", margin: "1rem 0" }}
          >
            {successMessage}
          </Typography>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ marginTop: "1rem" }}
        >
          Submit
        </Button>
      </CardContent>
    </Card>
  );
};

export default NewPost;
